"use strict";
// import { useEffect } from "react";
// import * as yup from "yup";
// import { useForm } from "react-hook-form";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { useParams } from "react-router";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { VerifyLoginFormData } from "../../../utils/api/auth/auth.type";
// import { useAppDispatch } from "../../../redux/hook";
// import { useVerifyUserMutation } from "../../../utils/api/auth/auth.api";
// import { onlogout, onSetUserToken } from "../../../redux/slice/User.slice";
// import { cleannerError } from "../../../utils/Utils";
// import toast from "react-hot-toast";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// const UseVerificationCodeForm = () => {
//     const validationSchema = yup.object().shape({
//         verify_code: yup
//             .string()
//             .required("Le code est un champs requis")
//             .label("Le code"),
//     });
//     const {
//         register,
//         handleSubmit,
//         formState: { errors },
//         clearErrors,
//         setError,
//     } = useForm<VerifyLoginFormData>({
//         resolver: yupResolver(validationSchema),
//     });
//     const navigate = useNavigate();
//     let params = useParams();
//     const dispatch = useAppDispatch();
//     const [verifyUser, { isLoading }] = useVerifyUserMutation();
//     const [urlParams] = useSearchParams();
//     useEffect(() => {
//         cleannerError(errors, clearErrors);
//     }, [errors, clearErrors]);
//     const onSubmit = async (data: VerifyLoginFormData) => {
//         const res = await verifyUser({ id: params?.userId, data: data });
//         if ("data" in res) {
//             if (res?.data?.success === true) {
//                 dispatch(
//                     onSetUserToken({
//                         user: res?.data.user,
//                         token: res?.data.access_token,
//                     })
//                 );
//                 if(res?.data?.user?.status === "user") {
//                     toast.error("Vous n'êtes pas autorisé à vous connecter sur la plateforme.", {
//                         duration: 5000,
//                         position: "top-center",
//                     });
//                     dispatch(onlogout());
//                     navigate("/");
//                 } else {
//                     toast.success("Vous êtes connecté avec succès.", {
//                         duration: 3000,
//                         position: "top-center",
//                     });
//                 }
//                 let path: string = "/admin/tableau-de-bord";
//                 const prev = urlParams.get('redirectTo');
//                 if(prev !== null){
//                     window.location.href = prev
//                 }else{
//                     window.location.href = path;
//                 }
//                 // navigate(path);
//             } else {
//                 let message = res?.data?.message
//                     ? res?.data?.message
//                     : `Une erreur de statut 400 est survenue.`;
//                 if (res?.data?.nosame_code === false) {
//                     toast.error(message, {
//                         duration: 5000,
//                         position: "top-center",
//                     });
//                 } else {
//                     toast.error(message, {
//                         duration: 5000,
//                         position: "top-center",
//                     });
//                     navigate("/");
//                 }
//             }
//         }
//     };
//     return {
//         register,
//         errors: errors,
//         onSubmit: handleSubmit(onSubmit),
//         isLoading,
//     };
// };
// export default UseVerificationCodeForm;
const react_1 = require("react");
const yup = __importStar(require("yup"));
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const react_router_1 = require("react-router");
const yup_1 = require("@hookform/resolvers/yup");
const hook_1 = require("../../../redux/hook");
const auth_api_1 = require("../../../utils/api/auth/auth.api");
const User_slice_1 = require("../../../redux/slice/User.slice");
const Utils_1 = require("../../../utils/Utils");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const UseVerificationCodeForm = () => {
    const validationSchema = yup.object().shape({
        verify_code: yup
            .string()
            .required("Le code est un champs requis")
            .label("Le code"),
    });
    const { register, handleSubmit, formState: { errors }, clearErrors, setError, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const navigate = (0, react_router_dom_1.useNavigate)();
    const params = (0, react_router_1.useParams)();
    const dispatch = (0, hook_1.useAppDispatch)();
    const [verifyUser, { isLoading }] = (0, auth_api_1.useVerifyUserMutation)();
    const [refreshToken] = (0, auth_api_1.useRefreshTokenMutation)();
    const [urlParams] = (0, react_router_dom_1.useSearchParams)();
    // 🔧 Nettoyage automatique des erreurs YUP
    (0, react_1.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const startTokenRefreshInterval = (token) => {
        // 45 minutes = 2700000 ms
        const interval = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const res = yield refreshToken({ token }).unwrap();
                if (res === null || res === void 0 ? void 0 : res.access_token) {
                    dispatch((0, User_slice_1.onSetUserToken)({
                        user: res === null || res === void 0 ? void 0 : res.user,
                        token: res === null || res === void 0 ? void 0 : res.access_token,
                    }));
                    localStorage.setItem("access_token", res === null || res === void 0 ? void 0 : res.access_token);
                    console.log("🔁 Token rafraîchi automatiquement à", new Date().toLocaleTimeString());
                }
            }
            catch (error) {
                console.error("Erreur lors du refresh automatique :", error);
                clearInterval(interval);
                react_hot_toast_1.default.error("Votre session a expiré. Veuillez vous reconnecter.", {
                    duration: 4000,
                    position: "top-center",
                });
                dispatch((0, User_slice_1.onlogout)());
                navigate("/");
            }
        }), 3 * 60 * 1000);
        // Sauvegarde pour pouvoir le clear plus tard
        localStorage.setItem("refresh_interval_id", interval.toString());
    };
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        const res = yield verifyUser({ id: params === null || params === void 0 ? void 0 : params.userId, data });
        if ("data" in res) {
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.success) === true) {
                const accessToken = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.access_token;
                const user = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.user;
                // Stockage du token dans Redux
                dispatch((0, User_slice_1.onSetUserToken)({ user, token: accessToken }));
                // Cas utilisateur non autorisé
                if ((user === null || user === void 0 ? void 0 : user.status) === "user") {
                    react_hot_toast_1.default.error("Vous n'êtes pas autorisé à vous connecter sur la plateforme.", {
                        duration: 5000,
                        position: "top-center",
                    });
                    dispatch((0, User_slice_1.onlogout)());
                    navigate("/");
                    return;
                }
                // Succès de la connexion
                react_hot_toast_1.default.success("Vous êtes connecté avec succès.", {
                    duration: 3000,
                    position: "top-center",
                });
                // Redirection
                const redirectTo = urlParams.get("redirectTo");
                window.location.href = redirectTo !== null && redirectTo !== void 0 ? redirectTo : "/admin/tableau-de-bord";
                // navigate(redirectTo ?? "/admin/tableau-de-bord");
            }
            else {
                const message = ((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.message) || "Une erreur est survenue.";
                react_hot_toast_1.default.error(message, { duration: 5000, position: "top-center" });
                if (((_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.nosame_code) !== false)
                    navigate("/");
            }
        }
    });
    // 🧹 Nettoyage de l’interval au démontage du hook
    (0, react_1.useEffect)(() => {
        return () => {
            const intervalId = localStorage.getItem("refresh_interval_id");
            if (intervalId) {
                clearInterval(Number(intervalId));
                localStorage.removeItem("refresh_interval_id");
            }
        };
    }, []);
    return {
        register,
        errors,
        onSubmit: handleSubmit(onSubmit),
        isLoading,
    };
};
exports.default = UseVerificationCodeForm;
